export enum UserStatus {
    ACTIVE = "active",
    SUSPEND = "suspend",
    DELETE = "delete",
}